/**
 * 渠道模块接口
 */

import areaApi from './areaApi';
import optionApi from './optionApi';
import settingApi from './settingApi';
import loginApi from './loginApi';
import importApi from './importApi';

export default {
  ...areaApi,
  ...optionApi,
  ...settingApi,
  ...loginApi,
  ...importApi,
};
